'use client'

import { setFooterTab } from '@/redux/features/filterSlice'
import { useGetAllBranchesQuery } from '@/redux/services/footerApi'
import { RootState } from '@/redux/store'
import cn from 'classnames'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { YMapsProvider } from '@/providers/YMapsProvider'
import Map, { MapTheme } from '@/components/Footer/Map'
import FooterContacts from '@/components/Footer/FooterContacts'
import FooterProduction from '@/components/Footer/FooterProduction'
import FooterMegakorm from '@/components/Footer/FooterMegakorm'
import ForPartners from '@/components/ForPartners/ForPartners'
import FooterBottom from '@/components/Footer/FooterBottom'

interface IProps {
    mapTheme?: MapTheme
}

const Footer: React.FC<IProps> = ({ mapTheme }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { footerTab } = useSelector((state: RootState) => state.filter)

    const { data: branches = [] } = useGetAllBranchesQuery()

    const [selectedChapters, setSelectedChapters] = useState<number>(null)

    const linksArray = [t('productions'), t('megakorm'), t('Feedback')]
    const megakormItem = {
        tag: t('distributors'),
        title: t('megakorm'),
        text: [t('footerText')],
        btn: {
            content: t('onMegakorm'),
            icon: 'sphera',
            link: 'https://megakorm.ru/'
        }
    }

    const handleBranchesDropdownToggle = useCallback((id: number) => () => {
        const isSelected = selectedChapters === id

        if (isSelected) {
            setSelectedChapters(null)
            return
        }
        setSelectedChapters(id)
    }, [selectedChapters])

    // useEffect(()=>{
    //     if(footerTab === 0) {
    //         dispatch(setFooterTab(1))
    //     } else if(footerTab === 3) {
    //         dispatch(setFooterTab(2))
    //     }
    // }, [footerTab])

    const isMiddleTabsActive = footerTab === 0 || footerTab === 1

    return (
        <footer
            className={cn('footer footer__grid')}
            id={'contact'}
            style={{ paddingTop: isMiddleTabsActive ? 133 : 85 }}
        >
            {isMiddleTabsActive ? (
                <YMapsProvider>
                    <Map
                        theme={mapTheme}
                        branches={branches}
                        onDropdownToggle={handleBranchesDropdownToggle}
                    />
                </YMapsProvider>
            ) : null}
            <ul className='footer__links'>
                {linksArray?.map((item, index) => (
                    <li
                    key={index}
                        onClick={() => dispatch(setFooterTab(index))}
                        className={`footer__links-item ${footerTab === index && 'footer__links-item_active'}`}
                    >
                        {item}
                    </li>
                ))}
            </ul>
            <div
                style={{ maxWidth: isMiddleTabsActive ? 448 : 'none' }}
                className={`footer__top-wrapper ${footerTab === 1 && 'footer__top-wrapper_overlay'}`}
            >
                <div
                    style={isMiddleTabsActive ? { height: 662 } : { zIndex: 12 }}
                    className={`footer__top ${isMiddleTabsActive ? 'footer__top_overlay' : ''}`}
                >
                    <div className='footer__overlay_overlay'></div>
                    {footerTab === 0 && <FooterProduction
                            branches={branches}
                            selectedChapters={selectedChapters}
                            onDropdownToggle={handleBranchesDropdownToggle}
                        />}
                    {footerTab === 1 && (
                        <FooterMegakorm item={megakormItem} />
                    )}
                    {/* {footerTab === 2 && <FooterMegakorm item={megakormItem} />} */}
                    {footerTab === 2 && <ForPartners title={false} />}
                </div>
            </div>
            <FooterBottom />

            {isMiddleTabsActive ? (
                <div className={`footer__shadow ${mapTheme == 'light' ? 'footer__shadow-white' : ''}`} />
            ) : null}
        </footer>
    )
}

export {Footer}